import "./titleBar.scss";

const TitleBar = ({children, className=""}) => {

    return (
        <div className={"d-flex align-items-center col-12 p-1 px-2 "+className}>
            {children}
        </div>
    );
}

export default TitleBar;